// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"43885e37","703":"86fdb2c7","787":"ac61e543"}[chunkId] + ".chunk.js";
};